const Header = () => {
  return (
    <div className="header">
      <span className="logo">Traffic Emission Dashboard by Ramboll</span>
    </div>
  )
};

export default Header;